import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-aviso-alteracao-regras',
  standalone: true,
  templateUrl: './modal-aviso-alteracao-regras.component.html',
  styleUrls: ['./modal-aviso-alteracao-regras.component.scss']
})
export class ModalAvisoAlteracaoRegrasComponent implements OnInit {
  private readonly STORAGE_KEY_BASE = 'modal_alteracao_regras_visualized';

  @Input() userId?: string;
  @Output() closed = new EventEmitter<void>();

  constructor(public bsModalRef?: BsModalRef) { }

  ngOnInit() {
    this.checkIfShouldShowModal();
  }

  private get storageKey(): string {
    return this.userId ? `${this.STORAGE_KEY_BASE}_${this.userId}` : this.STORAGE_KEY_BASE;
  }

  checkIfShouldShowModal() {
    const hasVisualized = localStorage.getItem(this.storageKey);
    if (hasVisualized && this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  closeModal() {
    localStorage.setItem(this.storageKey, 'true');
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    this.closed.emit();
  }

  onClose() {
    this.closeModal();
  }
}
